module.exports = __webpack_public_path__ + "img/download-QRcode2.de35ff74.png";